import { createContext, ReactNode, useContext, useState } from "react";
import { ThemeSettings } from "../interfaces";

export const ThemeContext = createContext<ThemeSettings>({
  current: "light",
  toggleTheme: undefined,
});

export interface ThemeProviderProps {
  children: ReactNode;
  theme: string;
}

export const ThemeProvider = ({ children, theme }: ThemeProviderProps) => {
  const [current, setCurrent] = useState(theme);
  const toggleTheme = () => {
    setCurrent((current) => (current === "light" ? "dark" : "light"));
  };

  return (
    <ThemeContext.Provider value={{ current, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const theme = useContext(ThemeContext);
  return theme;
};

export default useTheme;
